import './vendor';

import "./pages/map";
import "./pages/promo";
import "./pages/object";
import "./pages/event-list";
import "./pages/oneevent";
import "./pages/home-page";
import "./pages/one-route";
import "./general/header-modal";
import "./general/hamburger";
import "./general/yandex-map";


// WEBPACK FOOTER //
// ./src/js/main.js